/* conde-gallery.js
 * Client-side interactivity for the extensions gallery:
 *   - checkbox filter groups (Method / Color / Length / Texture)
 *   - sort dropdown (featured / best-selling / A-Z / Z-A) applied within each method group
 *   - view-by column toggle (3 / 4) applied to every grid
 *   - URL param sync on load (?method=volume-weft, ?color=solid, ...)
 *   - hero CTA preselect (data-gallery-preselect-color)
 *
 * DOM shape:
 *   .conde-gallery__groups
 *     .conde-gallery__method-group[data-method-group="volume-weft"]
 *       h2.conde-gallery__method-label
 *       .conde-gallery__grid[data-gallery-grid][data-columns]
 *         a.conde-gallery-card[data-method|data-color|data-length|data-texture]
 */
(function () {
  var groupsRoot = document.querySelector('[data-gallery-groups]');
  if (!groupsRoot) return;

  var stripEl = document.querySelector('.conde-gallery-methods');
  var emptyState = document.querySelector('[data-gallery-empty]');
  // The Allure sort snippet renders <select name="sort_by"> inside
  // .conde-gallery__sort — no `data-gallery-sort` hook is on it. Fall back
  // to querying the select by its container so bindSort() can attach.
  var sortSelect = document.querySelector('[data-gallery-sort]') ||
                   document.querySelector('.conde-gallery__sort select');
  var viewButtons = document.querySelectorAll('.conde-gallery__view-btn');
  var filterGroups = document.querySelectorAll('[data-filter-group]');

  // Mode label lookup for regrouping when mode != method. `method` is
  // included so drill-down subpages can pretty-print URL param values in
  // the extended breadcrumb (e.g. ?method=tape-weft → "TAPE WEFT").
  var MODE_DEFS = {
    method: [
      ['volume-weft','VOLUME WEFT'],['thin-weft','THIN WEFT'],['tape-weft','TAPE WEFT'],
      ['tape-in','TAPE-INS'],['k-tip','K-TIPS'],['bulk','BULK'],['clip-in','CLIP-INS']
    ],
    color: [
      ['solid','SOLID'],['balayage','BALAYAGE'],['bronde','BRONDE'],
      ['highlights','HIGHLIGHTS'],['superblend','SUPERBLEND'],
      ['rooted','ROOTED'],['fantasy','FANTASY']
    ],
    length: [
      ['18','18"'],['20','20"'],['22','22"'],
      ['24','24"'],['26','26"'],['28','28"']
    ],
    texture: [
      ['straight','STRAIGHT'],['body-wave','BODY WAVE'],['wavy','WAVY']
    ]
  };

  // Read gallery context from the section root — `root`, `method-subpage`,
  // `color-subpage`, `length-subpage`, or `texture-subpage`. Every drill-in
  // counts as a subpage so checkbox events do pure client-side filtering
  // (no mode rebucketing, no URL-driven regrouping — those only make sense
  // on the root landing where the user hasn't scoped to a tag yet).
  var galleryRoot = document.getElementById('conde-gallery');
  var galleryContext = galleryRoot ? (galleryRoot.getAttribute('data-context') || 'root') : 'root';
  var isSubpage = galleryContext !== 'root';

  // On root, the strip renders all four rows (method/color/length/texture)
  // in the DOM. CSS shows one based on [data-mode] on the strip. ?by= in
  // the URL flips the mode; anything else stays method (default). Liquid
  // can't read query params so this is the client-side swap.
  (function applyRootModeFromQuery() {
    if (galleryContext !== 'root') return;
    var strip = document.querySelector('.conde-gallery-methods');
    if (!strip) return;
    var by = new URL(window.location.href).searchParams.get('by');
    if (by === 'shade' || by === 'color') {
      strip.setAttribute('data-mode', 'color');
    } else if (by === 'length') {
      strip.setAttribute('data-mode', 'length');
    } else if (by === 'texture') {
      strip.setAttribute('data-mode', 'texture');
    }
  })();

  // Determine mode from URL (Liquid can't read query params).
  // Precedence: ?open=<key> > first ?color/?length/?texture/?method > default method
  function detectMode() {
    var params = new URL(window.location.href).searchParams;
    // ?by= (landing-axis hint on root) wins over legacy filter params so
    // /collections/extensions?by=shade renders color tiles in the strip.
    var by = params.get('by');
    if (by === 'shade' || by === 'color') return 'color';
    if (by === 'length') return 'length';
    if (by === 'texture') return 'texture';
    var open = params.get('open');
    if (open && ['method','color','length','texture'].indexOf(open) !== -1) return open;
    if (params.has('color')) return 'color';
    if (params.has('length')) return 'length';
    if (params.has('texture')) return 'texture';
    if (params.has('method')) return 'method';
    return 'method';
  }

  var mode = detectMode();
  if (stripEl) stripEl.setAttribute('data-mode', mode);
  groupsRoot.setAttribute('data-mode', mode);

  // Snapshot the server-rendered method-grouped HTML so switchMode() can
  // restore or rebucket from it any number of times without losing cards.
  var nextCardOrder = 0;
  groupsRoot.querySelectorAll('.conde-gallery-card').forEach(function (card) { card.dataset.galleryOrder = nextCardOrder++; });
  var sourceGroups = groupsRoot.cloneNode(true);

  // If mode != method on first load, rebuild the groups from the flat set of server-rendered cards.
  // Subpages keep the flat layout regardless of URL mode — no rebucketing.
  if (!isSubpage && mode !== 'method' && MODE_DEFS[mode]) {
    rebucketGroups(mode);
  }

  var groupEls = Array.prototype.slice.call(groupsRoot.querySelectorAll('[data-group]'));
  var grids = Array.prototype.slice.call(groupsRoot.querySelectorAll('[data-gallery-grid]'));
  var cards = Array.prototype.slice.call(groupsRoot.querySelectorAll('.conde-gallery-card'));

  // Store original per-grid order for "Featured" reset (after any rebucketing).
  var originalOrderByGrid = grids.map(function (g) {
    return Array.prototype.slice.call(g.querySelectorAll('.conde-gallery-card'));
  });

  function refreshElementRefs() {
    groupEls = Array.prototype.slice.call(groupsRoot.querySelectorAll('[data-group]'));
    grids = Array.prototype.slice.call(groupsRoot.querySelectorAll('[data-gallery-grid]'));
    cards = Array.prototype.slice.call(groupsRoot.querySelectorAll('.conde-gallery-card'));
    originalOrderByGrid = grids.map(function (g) {
      return Array.prototype.slice.call(g.querySelectorAll('.conde-gallery-card'));
    });
  }

  function switchMode(newMode) {
    if (newMode === mode) return;
    // Subpage layouts don't switch modes — they stay flat.
    if (isSubpage) return;
    mode = newMode;
    if (stripEl) stripEl.setAttribute('data-mode', mode);
    groupsRoot.setAttribute('data-mode', mode);
    // Restore method-grouped HTML (contains every card once), then rebucket
    // if the new mode is non-method.
    groupsRoot.replaceChildren.apply(groupsRoot, Array.from(sourceGroups.children, function (group) { return group.cloneNode(true); }));
    if (mode !== 'method' && MODE_DEFS[mode]) {
      rebucketGroups(mode);
    }
    refreshElementRefs();
    // The server-rendered HTML pins data-columns="3"; restore whatever
    // view the user had selected before the mode switch.
    var cols = currentColumns();
    grids.forEach(function (grid) { grid.setAttribute('data-columns', cols); });
  }

  function rebucketGroups(newMode) {
    var defs = MODE_DEFS[newMode];
    if (!defs) return;
    var seen = new Set();
    var allCards = Array.from(sourceGroups.querySelectorAll('.conde-gallery-card')).filter(function (card) {
      var key = card.dataset.productId || card.getAttribute('href') || card.id;
      if (key && seen.has(key)) return false;
      if (key) seen.add(key);
      return true;
    });

    // Wipe existing method groups; replace with new mode groups.
    groupsRoot.innerHTML = '';

    defs.forEach(function (def) {
      var handle = def[0];
      var label = def[1];
      var bucketCards = allCards.filter(function (card) {
        var attr = (card.getAttribute('data-' + newMode) || '').split(',');
        return attr.indexOf(handle) !== -1;
      });
      if (bucketCards.length === 0) return;

      var group = document.createElement('div');
      group.className = 'conde-gallery__method-group';
      group.setAttribute('data-group-key', newMode);
      group.setAttribute('data-group', handle);

      var h2 = document.createElement('h2');
      h2.className = 'conde-gallery__method-label';
      h2.id = 'group-' + handle;
      h2.textContent = label;
      group.appendChild(h2);

      var grid = document.createElement('div');
      grid.className = 'conde-gallery__grid';
      grid.setAttribute('data-gallery-grid', '');
      grid.setAttribute('data-columns', '3');

      bucketCards.forEach(function (card) {
        // clone so a card can appear in multiple buckets (length + texture)
        grid.appendChild(card.cloneNode(true));
      });

      group.appendChild(grid);
      groupsRoot.appendChild(group);
    });
  }

  function currentFilters() {
    var filters = {};
    filterGroups.forEach(function (group) {
      var key = group.getAttribute('data-filter-group');
      var checked = group.querySelectorAll('input[type="checkbox"]:checked');
      if (checked.length === 0) return;
      filters[key] = Array.prototype.map.call(checked, function (cb) {
        return cb.getAttribute('data-filter-value');
      });
    });
    return filters;
  }

  function cardMatches(card, filters, groupHandle, groupKey) {
    // The current grouping key is served by the group; skip it when filtering
    // individual cards so we don't double-count.
    // BUT: when the parent group is the synthetic 'all' bucket (flat layouts
    // like accessories), there's no real grouping-by-axis, so we must not
    // skip the mode filter here — otherwise checking METHOD boxes would be
    // silently ignored.
    for (var key in filters) {
      if (!filters.hasOwnProperty(key)) continue;
      if (key === groupKey && groupHandle && groupHandle !== 'all') continue;
      var attr = card.getAttribute('data-' + key) || '';
      var values = attr.split(',').filter(Boolean);
      var wanted = filters[key];
      var hit = false;
      for (var i = 0; i < wanted.length; i++) {
        if (values.indexOf(wanted[i]) !== -1) { hit = true; break; }
      }
      if (!hit) return false;
    }
    return true;
  }

  function applyFilters() {
    var filters = currentFilters();

    var totalVisible = 0;

    groupEls.forEach(function (group) {
      var handle = group.getAttribute('data-group');
      var groupKey = group.getAttribute('data-group-key') || mode;
      var groupFilter = filters[groupKey] || null;
      // Flat subpage layout uses a synthetic 'all' bucket that never matches
      // a filter value — bypass the group-level filter so the single group
      // stays visible; card-level filtering still runs below.
      var groupOK = !groupFilter || handle === 'all' || groupFilter.indexOf(handle) !== -1;
      if (!groupOK) {
        group.classList.add('is-hidden');
        return;
      }
      var groupCards = Array.prototype.slice.call(group.querySelectorAll('.conde-gallery-card'));
      var visibleInGroup = 0;
      groupCards.forEach(function (card) {
        var show = cardMatches(card, filters, handle, groupKey);
        card.classList.toggle('is-hidden', !show);
        if (show) visibleInGroup++;
      });
      group.classList.toggle('is-hidden', visibleInGroup === 0);
      totalVisible += visibleInGroup;
    });

    if (emptyState) emptyState.hidden = totalVisible !== 0;

    syncUrl(filters);
    // Layer-3 UI restructuring is intentionally NOT re-run on filter
    // changes. It only applies on initial page load (arrived at via
    // tile click's full navigation or a bookmarked deep-URL). Live
    // accordion checks just filter; they don't hide the accordion
    // itself or extend the breadcrumb — that would make the sidebar
    // vanish under the user's cursor mid-interaction.
  }

  function syncUrl(filters) {
    if (!window.history || !window.history.replaceState) return;
    var url = new URL(window.location.href);
    ['method', 'color', 'length', 'texture', 'price'].forEach(function (k) {
      if (!filters[k] || !filters[k].length) {
        url.searchParams.delete(k);
        return;
      }
      // If every box in this dimension is checked, treat as "no filter" and
      // drop the param — same visual state, cleaner URL.
      var group = document.querySelector('[data-filter-group="' + k + '"]');
      var total = group ? group.querySelectorAll('input[type="checkbox"]').length : 0;
      if (total > 0 && filters[k].length === total) {
        url.searchParams.delete(k);
      } else {
        url.searchParams.set(k, filters[k].join(','));
      }
    });
    window.history.replaceState({}, '', url.toString());
  }

  function openFilter(group) { group.classList.add('is-open'); setExpandedAttr(group, true); }
  function closeFilter(group) { group.classList.remove('is-open'); setExpandedAttr(group, false); }
  function isFilterOpen(group) { return group.classList.contains('is-open'); }
  function setExpandedAttr(group, val) {
    var btn = group.querySelector('.conde-gallery-filter__summary');
    if (btn) btn.setAttribute('aria-expanded', val ? 'true' : 'false');
  }

  function readUrlIntoCheckboxes() {
    var params = new URL(window.location.href).searchParams;
    filterGroups.forEach(function (group) {
      var key = group.getAttribute('data-filter-group');
      var raw = params.get(key);
      if (!raw) return;
      var wanted = raw.split(',');
      group.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
        if (wanted.indexOf(cb.getAttribute('data-filter-value')) !== -1) {
          cb.checked = true;
          var acc = cb.closest('.conde-gallery-filter');
          if (acc) openFilter(acc);
        }
      });
    });

    // ?open=method|color|length|texture -> pre-expand that accordion.
    // For color/length/texture modes, if the URL doesn't narrow the dimension
    // (no ?color=/?length=/?texture= specified), auto-check every box so the
    // sidebar visually confirms "all shades / all lengths / all textures".
    // Method mode stays unchecked-by-default — it's the "All" root state.
    var openKey = params.get('open');
    if (openKey) {
      filterGroups.forEach(function (group) {
        if (group.getAttribute('data-filter-group') === openKey) openFilter(group);
      });
    }
    if (mode !== 'method' && !params.get(mode)) {
      filterGroups.forEach(function (group) {
        if (group.getAttribute('data-filter-group') !== mode) return;
        openFilter(group);
        group.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
          cb.checked = true;
        });
      });
    }
  }

  function computeMode() {
    var priority = ['method', 'color', 'length', 'texture'];
    for (var i = 0; i < priority.length; i++) {
      var g = document.querySelector('[data-filter-group="' + priority[i] + '"]');
      if (g && g.querySelector('input[type="checkbox"]:checked')) return priority[i];
    }
    return 'method';
  }

  // Scroll so the exact bottom of the gallery hero lands at the top of the
  // viewport. getBoundingClientRect().bottom gives the distance from the
  // current viewport top to the element's bottom edge; adding scrollY
  // converts that to an absolute document position. Works on every screen
  // size because it reads the real rendered pixel, not a hardcoded vh value.
  function scrollToStrip() {
    var hero = document.querySelector('.ax-hero--gallery');
    if (!hero) return;
    var target = hero.getBoundingClientRect().bottom + window.scrollY;
    window.scrollTo({ top: target, behavior: 'smooth' });
  }

  // Shared handler for entry points that select ONE filter value and
  // land the user in the gallery (top strip tiles). Clears other checks
  // in the dimension (single-select), applies filters, optionally scrolls.
  function selectFilterValue(key, value, scrollToGallery) {
    var group = document.querySelector('[data-filter-group="' + key + '"]');
    if (!group) return;
    group.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
      cb.checked = false;
    });
    var cb = group.querySelector('input[data-filter-value="' + value + '"]');
    if (cb) cb.checked = true;
    openFilter(group);
    var newMode = computeMode();
    if (newMode !== mode) switchMode(newMode);
    applyFilters();
    if (scrollToGallery) scrollToStrip();
  }

  // Hero VIEW COLLECTION CTA: pure scroll to the strip. Does not select
  // any filter — a plain "scroll to the gallery" action.
  function handleHeroCTA() {
    var cta = document.querySelector('.conde-gallery-hero__cta');
    if (!cta) return;
    cta.addEventListener('click', function (e) {
      e.preventDefault();
      scrollToStrip();
    });
  }

  function bindStripTiles() {
    // Tiles are navigation — always. Real anchor href, full page load.
    // Accordions do the in-place filter. Different jobs, different feel.
    // Prefetch each tile's destination on hover so the click still feels
    // instant when it fires.
    var tiles = document.querySelectorAll('.conde-gallery-methods__tile[href]');
    tiles.forEach(function (tile) {
      var prefetched = false;
      tile.addEventListener('mouseenter', function () {
        if (prefetched) return;
        prefetched = true;
        var link = document.createElement('link');
        link.rel = 'prefetch';
        link.href = tile.getAttribute('href');
        document.head.appendChild(link);
      });
    });
  }

  function prettifyValue(axis, value) {
    var def = (MODE_DEFS[axis] || []).find(function (entry) { return entry[0] === value; });
    return def ? def[1] : '';
  }

  function buildBreadcrumb(root, mid, tail) {
    function element(tag, className, text) {
      var node = document.createElement(tag);
      node.className = 'conde-gallery-breadcrumb' + className;
      if (text) node.textContent = text;
      return node;
    }
    function link(className, label, href) {
      var node = element('a', className, label);
      var url = new URL(href || '/', window.location.origin);
      node.href = url.origin === window.location.origin ? url.href : '/';
      return node;
    }
    var nav = element('nav', '');
    nav.setAttribute('aria-label', 'Breadcrumb');
    var list = element('ol', '__list');
    nav.appendChild(list);
    [root, mid, tail].filter(Boolean).forEach(function (part, index) {
      if (index) {
        var sep = element('li', '__sep', '›');
        sep.setAttribute('aria-hidden', 'true');
        list.appendChild(sep);
      }
      var item = element('li', '__item');
      if (part === tail) {
        var chip = element('span', '__chip conde-gallery-breadcrumb__chip--active');
        chip.appendChild(element('span', '__chip-label', part.label));
        var close = link('__close', '×', part.url);
        close.setAttribute('aria-label', 'Remove ' + part.label + ' filter');
        chip.appendChild(close);
        item.appendChild(chip);
      } else {
        item.appendChild(link('__chip', part.label, part.url));
      }
      list.appendChild(item);
    });
    return nav;
  }

  // On drill-down subpages, reconcile the visible UI with the current URL
  // sibling-axis state (?color=X on a method subpage, ?method=X on a color
  // subpage). Runs on init AND after every filter change so sidebar checks
  // that end up as a single-value URL param upgrade the UI to layer 3
  // (row hidden, breadcrumb extended). Idempotent — safe to re-run.
  //
  //   0 values checked   → sibling row visible, breadcrumb stays layer 2
  //   1 value checked    → sibling row hidden, breadcrumb extended to layer 3
  //   2+ values checked  → sibling row visible, breadcrumb stays layer 2
  function applySubpageURLState() {
    // Layer-3 handling is intentionally scoped to method-subpage + ?color=
    // only (method → color drill pattern: click a color tile
    // on /volume-weft to arrive at /volume-weft?color=solid). In that
    // specific state:
    //   - hide the strip's color row (we've committed to that color)
    //   - hide the COLOR accordion (same reason)
    //   - extend breadcrumb to Extensions › VOLUME WEFT › SOLID ×
    //   - × on SOLID returns to /volume-weft (strips ?color=)
    // For any other drill-in (shade/length/texture) or any other filter
    // change on method-subpage, do nothing — accordions filter in place
    // without restructuring the layout.
    if (galleryContext !== 'method-subpage') return;

    var params = new URL(window.location.href).searchParams;
    var raw = params.get('color');
    var colorValues = raw ? raw.split(',').filter(function (value) { return !!prettifyValue('color', value); }) : [];

    var stripSection = document.querySelector('.conde-gallery-methods');
    var colorGroup = document.querySelector('[data-filter-group="color"]');
    var slot = document.querySelector('.conde-gallery__breadcrumb-slot');

    if (colorValues.length === 1) {
      // Hide the entire strip section (not just the color row) so its
      // outer padding collapses too — otherwise layer 3 shows a big
      // vertical gap where the hidden row used to be.
      if (stripSection) stripSection.classList.add('is-url-hidden');
      if (colorGroup) colorGroup.classList.add('is-url-hidden');
      if (slot) {
        var rootLabel = slot.getAttribute('data-breadcrumb-root-label');
        var rootUrl = slot.getAttribute('data-breadcrumb-root-url');
        var midLabel = slot.getAttribute('data-breadcrumb-mid-label');
        var midUrl = slot.getAttribute('data-breadcrumb-mid-url');
        var tailLabel = prettifyValue('color', colorValues[0]);
        slot.replaceChildren(buildBreadcrumb(
          { label: rootLabel, url: rootUrl },
          { label: midLabel, url: midUrl },
          { label: tailLabel, url: midUrl }
        ));
      }
    } else {
      if (stripSection) stripSection.classList.remove('is-url-hidden');
      if (colorGroup) colorGroup.classList.remove('is-url-hidden');
      if (slot) {
        var rL = slot.getAttribute('data-breadcrumb-root-label');
        var rU = slot.getAttribute('data-breadcrumb-root-url');
        var mL = slot.getAttribute('data-breadcrumb-mid-label');
        slot.replaceChildren(buildBreadcrumb(
          { label: rL, url: rU },
          null,
          { label: mL, url: rU }
        ));
      }
    }
  }

  function bindFilterEvents() {
    filterGroups.forEach(function (group) {
      group.addEventListener('change', function (e) {
        if (!e.target || !e.target.matches('input[type="checkbox"]')) return;
        // Sidebar accordions are pure filters: they hide/show cards in place
        // but never change the pivot axis. The pivot is fixed once at page
        // load — by ?by= on root, or by the drill-in tag on subpages — and
        // is what determines which tile row and group bucketing show. If we
        // switched mode here, checking Volume Weft while shopping by length
        // would flip the top strip from length tiles to method tiles, which
        // is not what users expect from a filter control.
        applyFilters();
      });
      var summary = group.querySelector('.conde-gallery-filter__summary');
      if (!summary) return;
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        var wasOpen = isFilterOpen(group);
        // Accordion behavior: close others when opening this one.
        filterGroups.forEach(function (other) {
          if (other !== group) closeFilter(other);
        });
        if (wasOpen) closeFilter(group); else openFilter(group);
      });
    });
  }

  function applySort(value) {
    grids.forEach(function (grid, idx) {
      var sorted = originalOrderByGrid[idx].slice().sort(function (a, b) { return Number(a.dataset.galleryOrder) - Number(b.dataset.galleryOrder); });
      if (value === 'title-ascending') {
        sorted.sort(compareTitle(1));
      } else if (value === 'title-descending') {
        sorted.sort(compareTitle(-1));
      } else if (value === 'price-ascending') {
        sorted.sort(comparePrice(1));
      } else if (value === 'price-descending') {
        sorted.sort(comparePrice(-1));
      } // 'best-selling' / 'manual' / 'featured' / other -> restore original
      sorted.forEach(function (card) { grid.appendChild(card); });
    });
  }

  function compareTitle(dir) {
    return function (a, b) {
      var ta = (a.querySelector('.conde-gallery-card__title') || {}).textContent || '';
      var tb = (b.querySelector('.conde-gallery-card__title') || {}).textContent || '';
      return ta.localeCompare(tb) * dir;
    };
  }

  function parsePrice(el) {
    var price = Number(el.getAttribute('data-price-cents'));
    return Number.isFinite(price) ? price : 0;
  }

  function comparePrice(dir) {
    return function (a, b) {
      return (parsePrice(a) - parsePrice(b)) * dir;
    };
  }

  function bindSort() {
    if (!sortSelect) return;
    sortSelect.addEventListener('change', function () {
      applySort(sortSelect.value);
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
  }

  function currentColumns() {
    var active = document.querySelector('.conde-gallery__view-btn.is-active');
    return (active && active.getAttribute('data-columns')) || '3';
  }

  function bindView() {
    viewButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cols = btn.getAttribute('data-columns');
        if (!cols) return;
        grids.forEach(function (grid) { grid.setAttribute('data-columns', cols); });
        viewButtons.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
  }

  // Infinite scroll: paginate is capped by Shopify around 250, so once the
  // sentinel enters the viewport we fetch the next paginated page URL
  // (stored on groupsRoot's data-next-page attribute), parse the returned
  // HTML, append each card to its matching method group, then update the
  // sentinel's target to the response's own data-next-page. Removes the
  // sentinel when there are no more pages. No hardcoded product count,
  // scales to any collection size.
  function bindInfiniteScroll() {
    var sentinel = document.querySelector('[data-gallery-sentinel]');
    if (!sentinel) return;
    if (!('fetch' in window)) return;
    var nextLink = document.querySelector('[data-gallery-next]');
    var status = document.querySelector('[data-gallery-status]');

    var SKELETON_COUNT = 6;         // one row of placeholder cards
    var SKELETON_SHOW_DELAY = 200;  // ms; skip skeleton on fast fetches
    var isLoading = false;

    // JS-generated placeholder card matching the real card's shape so the
    // grid layout doesn't shift when real cards replace it.
    function buildSkeletonCard() {
      var card = document.createElement('div');
      card.className = 'conde-gallery-card conde-gallery-card--skeleton';
      card.setAttribute('aria-hidden', 'true');
      card.innerHTML =
        '<div class="conde-gallery-card__media conde-skeleton-block"></div>' +
        '<div class="conde-gallery-card__body">' +
          '<div class="conde-skeleton-line conde-skeleton-line--title"></div>' +
          '<div class="conde-skeleton-line conde-skeleton-line--price"></div>' +
          '<div class="conde-skeleton-line conde-skeleton-line--swatches"></div>' +
        '</div>';
      return card;
    }

    function buildSkeletonRow() {
      var row = document.createElement('div');
      row.className = 'conde-gallery__grid conde-gallery__skeleton';
      row.setAttribute('data-gallery-skeleton', '');
      row.setAttribute('data-columns', currentColumns());
      for (var i = 0; i < SKELETON_COUNT; i++) row.appendChild(buildSkeletonCard());
      return row;
    }

    function loadNext(manual) {
      if (isLoading) return;
      var nextUrl = groupsRoot.getAttribute('data-next-page');
      if (!nextUrl) { sentinel.remove(); if (nextLink) nextLink.hidden = true; return; }
      isLoading = true;
      groupsRoot.setAttribute('aria-busy', 'true');
      if (status) status.textContent = status.dataset.loading;

      // Delay-showing the skeleton so fast fetches don't flash a placeholder.
      var skeletonRow = null;
      var showSkeletonTimer = setTimeout(function () {
        skeletonRow = buildSkeletonRow();
        groupsRoot.parentNode.insertBefore(skeletonRow, sentinel);
      }, SKELETON_SHOW_DELAY);

      function cleanupSkeleton() {
        clearTimeout(showSkeletonTimer);
        if (skeletonRow && skeletonRow.parentNode) skeletonRow.parentNode.removeChild(skeletonRow);
      }

      fetch(nextUrl, { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var incomingRoot = doc.querySelector('[data-gallery-groups]');
          if (!incomingRoot) throw new Error('Missing gallery');

          incomingRoot.querySelectorAll('.conde-gallery-card').forEach(function (card) { card.dataset.galleryOrder = nextCardOrder++; });

          function mergeInto(target) {
            incomingRoot.querySelectorAll('[data-group]').forEach(function (incomingGroup) {
              var existing = Array.from(target.querySelectorAll('[data-group]')).find(function (group) {
                return group.dataset.group === incomingGroup.dataset.group;
              });
              if (!existing) {
                target.appendChild(incomingGroup.cloneNode(true));
                return;
              }
              var grid = existing.querySelector('[data-gallery-grid]');
              incomingGroup.querySelectorAll('.conde-gallery-card').forEach(function (card) {
                var duplicate = Array.from(grid.querySelectorAll('.conde-gallery-card')).some(function (loaded) {
                  return card.dataset.productId && loaded.dataset.productId === card.dataset.productId;
                });
                if (!duplicate) grid.appendChild(card.cloneNode(true));
              });
            });
          }
          mergeInto(sourceGroups);
          if (!isSubpage && mode !== 'method') rebucketGroups(mode);
          else mergeInto(groupsRoot);

          // Roll the next-page pointer forward. Remove sentinel when done.
          var nextNext = incomingRoot.getAttribute('data-next-page') || '';
          groupsRoot.setAttribute('data-next-page', nextNext);
          if (!nextNext) sentinel.remove();
          if (nextLink) {
            nextLink.hidden = !nextNext;
            if (nextNext) nextLink.href = nextNext;
          }
          if (status) status.textContent = '';

          refreshElementRefs();
          // Any grids that arrived from the fetch ship with the server default
          // data-columns="3" — sync them to whatever view the user picked.
          var cols = currentColumns();
          grids.forEach(function (grid) { grid.setAttribute('data-columns', cols); });
          applyFilters();
          if (sortSelect) applySort(sortSelect.value);
          if (manual || document.activeElement === nextLink) {
            var incomingIds = new Set(Array.from(incomingRoot.querySelectorAll('.conde-gallery-card'), function (card) { return card.dataset.productId; }));
            var firstNew = cards.find(function (card) {
              return incomingIds.has(card.dataset.productId) && !card.classList.contains('is-hidden') && !card.closest('.is-hidden');
            });
            var focusTarget = firstNew && (firstNew.matches('a[href]') ? firstNew : firstNew.querySelector('a[href], button'));
            if (focusTarget) focusTarget.focus();
          }
        })
        .catch(function () {
          if (status) status.textContent = status.dataset.error;
        })
        .finally(function () { cleanupSkeleton(); isLoading = false; groupsRoot.removeAttribute('aria-busy'); });
    }

    // rootMargin fires the load ~1 viewport before the sentinel actually
    // enters the visible area, so the next page is usually ready by the
    // time the user scrolls into it.
    if (nextLink) nextLink.addEventListener('click', function (event) {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      loadNext(true);
    });
    if (!('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { if (entry.isIntersecting) loadNext(); });
    }, { rootMargin: '1200px 0px' });

    observer.observe(sentinel);
  }

  // Canonical URL override for Layer 3 pages.
  //   /collections/extensions/tape-weft?color=solid  (method-first)
  //   /collections/extensions/solid?method=tape-weft (color-first)
  // return identical products. Google would see this as duplicate content
  // and pick one arbitrarily as canonical. Standardize on method-first so
  // SEO signal consolidates on that single URL variant.
  (function fixCanonicalOnLayer3() {
    var canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) return;
    var url = new URL(window.location.href);
    var prefix = url.pathname.match(/^(.*\/collections\/extensions\/)/);
    if (!prefix) return;
    var tag = url.pathname.split('/').pop();
    var colorHandles = 'solid,balayage,bronde,highlights,superblend,rooted,fantasy'.split(',');
    var methodParam = url.searchParams.get('method');
    // Color subpage + ?method= param → rewrite canonical to method-first form.
    if (colorHandles.indexOf(tag) !== -1 && prettifyValue('method', methodParam)) {
      canonical.href = url.origin + prefix[1] + encodeURIComponent(methodParam) + '?color=' + tag;
    }
  })();

  readUrlIntoCheckboxes();
  bindFilterEvents();
  bindSort();
  bindView();
  handleHeroCTA();
  bindStripTiles();
  bindInfiniteScroll();
  applySubpageURLState();
  applyFilters();
  if (sortSelect) applySort(sortSelect.value);
})();

